import { Location, NavigateFunction } from 'react-router-dom'

import getBasePath from '@/helpers/get-base-path'

const closeModal = (
  location: Location,
  navigate: NavigateFunction,
  pathOnClose?: string,
) => {
  if (!location && !navigate) {
    return
  }

  const path = pathOnClose || getBasePath(location.pathname)

  navigate(path || '/')

  return path || '/'
}

export default closeModal
